/**
 * EF-SUPERADMIN-TENANT-SWITCH-V1: Tenant Context Banner
 * 
 * Shows a banner when superadmin is viewing a specific tenant.
 * Provides quick way to exit tenant view.
 */

import React from 'react';
import { useTenantContext } from '../../context/TenantContext';
import { Button } from '../ui/button';
import { Building2, X } from 'lucide-react';

export default function TenantContextBanner() {
  const {
    isSuperAdmin,
    isViewingTenant,
    selectedTenant,
    selectedTenantId,
    clearTenant,
  } = useTenantContext();

  // Only show for superadmins viewing a tenant
  if (!isSuperAdmin || !isViewingTenant) return null;

  const tenantName = selectedTenant?.company_name || selectedTenantId;

  return (
    <div 
      className="bg-amber-500/10 border-b border-amber-500/30 px-4 py-2 flex items-center justify-between"
      data-testid="tenant-context-banner"
    >
      <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400">
        <Building2 className="h-4 w-4" />
        <span className="text-sm font-medium">
          Viewing as: <span className="font-bold">{tenantName}</span>
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={clearTenant}
        className="h-7 text-xs text-amber-600 dark:text-amber-400 hover:text-amber-700 hover:bg-amber-500/20"
        data-testid="exit-tenant-view"
      >
        <X className="h-3 w-3 mr-1" />
        Exit Tenant View
      </Button>
    </div>
  );
}
